// Use the same serializer as .sb3 saving, including extension blocks and mutations.
const getProjectJson = (vm, scope) => {
    const target = vm.editingTarget;
    if (scope === 'target' && !target) return {text: '', name: ''};
    const data = JSON.parse(scope === 'target' ? vm.toJSON(target.id) : vm.toJSON());
    return {
        text: JSON.stringify(data, null, 2),
        name: scope === 'target' ? data.name : ''
    };
};

export {getProjectJson};
